import React, { useState } from 'react';
import Modal from './Modal';
import { SUPPORT_EMAIL } from '../config';
import f from './forms.module.css';

const encode = (data) =>
  Object.keys(data)
    .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(data[k] || ''))
    .join('&');

export default function NewsletterModal({ onClose }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [bot, setBot] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const response = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encode({
          'form-name': 'newsletter',
          name,
          email,
          'bot-field': bot,
        }),
      });
      if (!response.ok) throw new Error('Submission failed');
      setDone(true);
    } catch (err) {
      setError(`Couldn't sign you up. Email us at ${SUPPORT_EMAIL} and we'll add you manually.`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal open onClose={onClose} label="Join the newsletter" size="md">
      {!done ? (
        <>
          <span className={f.label}>Newsletter</span>
          <h2 className={f.title}>
            Get the <em>drops</em> first.
          </h2>
          <p className={f.body}>
            Themes, dates, locations — straight to your inbox the moment they
            lock. No spam, just the next experience.
          </p>

          <form
            onSubmit={submit}
            name="newsletter"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
          >
            <input type="hidden" name="form-name" value="newsletter" />
            <p hidden>
              <label>
                Don't fill this out:
                <input
                  name="bot-field"
                  value={bot}
                  onChange={(e) => setBot(e.target.value)}
                />
              </label>
            </p>

            <div className={f.field}>
              <label className={f.fieldLabel}>Name</label>
              <input
                className={f.input}
                type="text"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className={f.field}>
              <label className={f.fieldLabel}>Email</label>
              <input
                className={f.input}
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            {error && <p className={f.errorMsg}>{error}</p>}

            <button type="submit" className={f.primary} disabled={submitting}>
              {submitting ? 'Sending…' : 'Sign me up'}
              <span aria-hidden="true">→</span>
            </button>
          </form>
        </>
      ) : (
        <>
          <span className={f.label}>You're in</span>
          <h2 className={f.title}>See you at the next one.</h2>
          <p className={f.body}>
            We'll send the next location and theme as soon as it's locked. In
            the meantime, follow along on Instagram for live updates.
          </p>
          <button className={f.primary} onClick={onClose}>Close</button>
        </>
      )}
    </Modal>
  );
}
